import React from "react";
import { ActionButton, useDeviceTypes } from "halifax";
import clsx from "clsx";
import {
  useCheckoutState,
  useCheckoutStateSelector as useSelector,
} from "@capone/checkout";

import { Event, TEvent } from "../../state/events";
import { ActivityMachineContext } from "../../state/types";
import { PickupPoint, SelectLang, SpecialRequirementArea } from "./components";
import styles from "./styles.module.scss";
import { ActivityAdditionalDetailsSelectors } from "../../../../checkout";
import { CONTINUE_TEXT } from "../../../common/textConstants";

export const AdditionalDetails = () => {
  const [, send] = useCheckoutState<TEvent, ActivityMachineContext>();
  const { matchesMobile } = useDeviceTypes();

  const hasPickupLocationField = useSelector(
    ActivityAdditionalDetailsSelectors.getHasPickupLocationField
  );
  const productOptionLangGuides = useSelector(
    ActivityAdditionalDetailsSelectors.getBookableLangGuides
  );
  const hasSpecialRequirementField = useSelector(
    ActivityAdditionalDetailsSelectors.getHasSpecialRequirementField
  );

  return (
    <>
      <div
        className={clsx(styles["additional-details-container"], {
          [styles.mobile]: matchesMobile,
        })}
      >
        {hasPickupLocationField && <PickupPoint />}
        {productOptionLangGuides.length > 1 && <SelectLang />}
        {hasSpecialRequirementField && <SpecialRequirementArea />}
      </div>
      {!matchesMobile && (
        <ActionButton
          onClick={() => send(Event.NEXT)}
          message={CONTINUE_TEXT}
          className="activity-continue-button"
        />
      )}
    </>
  );
};
